"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _get = _interopRequireDefault(require("./get"));

var _values = _interopRequireDefault(require("./values"));

var _default = (0, _unmutable["default"])({
  name: 'first',
  immutable: 'first',
  array: function array() {
    return (0, _get["default"])(0);
  },
  all: function all() {
    return function (value) {
      return (0, _values["default"])()(value).next().value;
    };
  }
});

exports["default"] = _default;